module.exports = __webpack_public_path__ + "img/pseudopop-in-teal.fc29dce1.png";